export default __webpack_public_path__ + "static/media/vietcom-hai.6a7ad709.jpg";